import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { } from '../actions'
import { getBlogDescriptionString } from '../utils'

const blog = {
    title: 'Blog Title',
    description: 'Blog Description',
    href: 'blog1'
}

class blogComponentLandscape extends Component {

    openBlog(URL) {
        window.open('/blog/' + URL)
    }

    render() {
        const blog = this.props.blog
        return (
            <Row style={{ paddingTop: 20 }}>
                <div>
                    <Col xs={7} sm={7} md={7} lg={7}>
                        <image onClick={() => { this.openBlog(blog.URL) }} style={{ width: '100%', cursor: 'pointer' }} src={blog.thumbnailImage} />
                    </Col>
                    <Col style={{ paddingLeft: 0 }} xs={5} sm={5} md={5} lg={5}>
                        <div className='hidden-xs'>
                            <h4 onClick={() => { this.openBlog(blog.URL) }} style={{ cursor: 'pointer', marginTop: 5 }}>{blog.articleName}</h4>
                            <p onClick={() => { this.openBlog(blog.URL) }} style={{ cursor: 'pointer' }} className='hidden-xs hidden-sm hidden-md' style={{ cursor: 'pointer', color: 'grey', wordWrap: 'break-word' }}>{getBlogDescriptionString(blog.description, 125)}</p>
                            <p onClick={() => { this.openBlog(blog.URL) }} style={{ cursor: 'pointer' }} className='hidden-xs hidden-sm hidden-lg' style={{ cursor: 'pointer', color: 'grey', wordWrap: 'break-word' }}>{getBlogDescriptionString(blog.description, 100)}</p>
                            <p onClick={() => { this.openBlog(blog.URL) }} style={{ cursor: 'pointer' }} className='hidden-xs hidden-md hidden-lg' style={{ cursor: 'pointer', color: 'grey', wordWrap: 'break-word' }}>{getBlogDescriptionString(blog.description, 70)}</p>
                            <p onClick={() => { this.openBlog(blog.URL) }} style={{ cursor: 'pointer' }} className='hidden-sm hidden-md hidden-lg' style={{ cursor: 'pointer', color: 'grey', wordWrap: 'break-word' }}>{getBlogDescriptionString(blog.description, 70)}</p>
                            {/* <a className='pull-right' href={'/blog/' + blog.URL} target='_blank'>
                                อ่านเพิ่มเติม..
                </a> */}
                        </div>
                        <div className='hidden-sm hidden-md hidden-lg'>
                            <h5 onClick={() => { this.openBlog(blog.URL) }} style={{ cursor: 'pointer', marginTop: 5 }}>{blog.articleName}</h5>
                            <p onClick={() => { this.openBlog(blog.URL) }} style={{ cursor: 'pointer' }} className='hidden-xs hidden-sm hidden-md' style={{ cursor: 'pointer', color: 'grey', wordWrap: 'break-word' }}>{getBlogDescriptionString(blog.description, 125)}</p>
                            <p onClick={() => { this.openBlog(blog.URL) }} style={{ cursor: 'pointer' }} className='hidden-xs hidden-sm hidden-lg' style={{ cursor: 'pointer', color: 'grey', wordWrap: 'break-word' }}>{getBlogDescriptionString(blog.description, 100)}</p>
                            <p onClick={() => { this.openBlog(blog.URL) }} style={{ cursor: 'pointer' }} className='hidden-xs hidden-md hidden-lg' style={{ cursor: 'pointer', color: 'grey', wordWrap: 'break-word' }}>{getBlogDescriptionString(blog.description, 70)}</p>
                            <p onClick={() => { this.openBlog(blog.URL) }} style={{ cursor: 'pointer' }} className='hidden-sm hidden-md hidden-lg' style={{ cursor: 'pointer', color: 'grey', wordWrap: 'break-word' }}>{getBlogDescriptionString(blog.description, 70)}</p>
                            {/* <a style={{ fontSize: '10px' }} className='pull-right' href={'/blog/' + blog.URL} target='_blank'>
                                อ่านเพิ่มเติม..
                </a> */}
                        </div>
                    </Col>
                    <a className='pull-right' style={{ position: 'absolute', bottom: 5, right: 20 }} href={'/blog/' + blog.URL} target='_blank'>
                        อ่านเพิ่มเติม..
                </a>
                </div>
            </Row>
        )
    }
}

export default connect(null, {})(blogComponentLandscape)


// WEBPACK FOOTER //
// ./src/components/blogComponentLandscape.js